import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAcb_list } from '../../store';
import './DiagramPage.css';
import diag1 from '../../image/diagram_image/diagram-1.png';
import diag2 from '../../image/diagram_image/diagram-2.png';
import diag3 from '../../image/diagram_image/diagram-3.png';
import diag4 from '../../image/diagram_image/diagram-4.png';
import diag5 from '../../image/diagram_image/diagram-5.png';
import diag6 from '../../image/diagram_image/diagram-6.png';


function ACBCard({ v = 0, a = 0, kw = 0, mwh = 0, style }) {
  const f = (x) => (Number.isFinite(x) ? x : 0);
  return (
    <div className="acb-card" style={style}>
      <div className="acb-title">MCCB</div>
      <div className="acb-row"><span>전압</span><b>{f(v).toFixed(1)}</b><small>V</small></div>
      <div className="acb-row"><span>전류</span><b>{f(a).toFixed(1)}</b><small>A</small></div>
      <div className="acb-row"><span>전력</span><b>{f(kw).toFixed(1)}</b><small>kW</small></div>
      <div className="acb-row"><span>누적</span><b>{f(mwh).toFixed(1)}</b><small>MWh</small></div>
    </div>
  );
}

export default function DiagramPage() {
  const dispatch = useDispatch();


  const Acb_list = useSelector((state) => state.Acb_list || {});
  const acbData  = useSelector((state) => state.acbData || {});


  useEffect(() => { dispatch(fetchAcb_list()); }, [dispatch]);

  // ===== 스케일(필요시 조정) =====
  // ACB
  const SCALE_V_A = 1;        // raw -> 실제 V/A
  const SCALE_P_KW = 1_000;  // raw 전력 -> kW
  const SCALE_E_MWH = 1_000_000; // raw 누적 -> MWh

  // ACB: seq 순서로 매핑
  const getAcbByIndex = (displayIndex) => {
    const seq = Acb_list?.seq?.[displayIndex];
    if (seq == null) return { v: 0, a: 0, kw: 0, mwh: 0 };

    const idx = acbData?.seq ? acbData.seq.indexOf(seq) : -1;
    if (idx < 0) return { v: 0, a: 0, kw: 0, mwh: 0 };

    const rawV  = acbData.voltage?.[idx] ?? 0;
    const rawA  = acbData.current?.[idx] ?? 0;
    const rawP  = acbData.power?.[idx] ?? 0;
    const rawWh = acbData.Add_power?.[idx] ?? 0;



    return {
      v:   rawV / SCALE_V_A,
      a:   rawA / SCALE_V_A,
      kw:  rawP / SCALE_P_KW,
      mwh: rawWh / SCALE_E_MWH,
    };

  };

  // ===== 좌표(패널당 ACB 2개) =====
  const PANELS = [
    { src: diag1,
      acbPos: [ { top: '6.5%',  right: '-0.2%' }, { top: '42.8%', right: '-0.2%' } ],
      invPos: [ { bottom: '8%', left: '21%' }, { bottom: '8%', left: '45.5%' }, { bottom: '8%', left: '70%' } ],
    },
    { src: diag2,
      acbPos: [ { top: '6.5%',  right: '-0.2%' }, { top: '42.8%', right: '-0.2%' } ],
      invPos: [ { bottom: '8%', left: '21%' }, { bottom: '8%', left: '45.5%' }, { bottom: '8%', left: '70%' } ],
    },
    { src: diag3,
      acbPos: [ { top: '6.5%',  right: '-0.2%' }, { top: '42.8%', right: '-0.2%' } ],
      invPos: [ { bottom: '8%', left: '21%' }, { bottom: '8%', left: '45.5%' }, { bottom: '8%', left: '70%' } ],
    },
    { src: diag4,
      acbPos: [ { top: '6.5%',  right: '-0.2%' }, { top: '42.8%', right: '-0.2%' } ],
      invPos: [ { bottom: '8%', left: '21%' }, { bottom: '8%', left: '45.5%' }, { bottom: '8%', left: '70%' } ],
    },
    { src: diag5,
      acbPos: [ { top: '5.5%',  right: '-0.2%' }, { top: '42.8%', right: '-0.2%' } ],
      invPos: [ { bottom: '8%', left: '21%' }, { bottom: '8%', left: '45.5%' }, { bottom: '8%', left: '70%' } ],
    },
    { src: diag6,
      acbPos: [ { top: '5.5%',  right: '-0.2%' }, { top: '42.8%', right: '-0.2%' } ],
      invPos: [ { bottom: '8%', left: '21%' }, { bottom: '8%', left: '45.5%' }, { bottom: '8%', left: '70%' } ],
    },
  ];

  // 전역 인덱스(ACB: 0~7)
  let acbIdx = 0;

  return (
    <div className="diagram-main-Public-wrap" style={{ padding: '31px' }}>
      <div className="Measurement-wrap">
        <div className="diagram-grid">
          {PANELS.map((p, pIdx) => (
            <figure className="diagram-item" key={pIdx}>
              <img src={p.src} alt={`diagram ${pIdx + 1}`} />

              {/* ACB (실시간) */}
              {p.acbPos.map((style, i) => {
                const { v, a, kw, mwh } = getAcbByIndex(acbIdx);
                acbIdx += 1;
                return <ACBCard key={`acb-${pIdx}-${i}`} v={v} a={a} kw={kw} mwh={mwh} style={style} />;
              })}
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
}
